import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { serpDifficuly } from '@/helpers/serpDifficulity';
import { getColor } from '@/helpers/utils';
import { Card, Dropdown } from 'react-bootstrap';
import { Doughnut } from 'react-chartjs-2';
import { serpTooltips } from '@/app/Serp/tooltip/serpTooltips';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import SemiCircleChartSkeleton from '@/app/common/components/skeleton/SemiCircleChartSkeleton';
import type { ChartOptions } from 'chart.js';

interface DoughnutCardProps {
  diff: number;
}

const doughnutOptions = {
  rotation: -90,
  circumference: 180,
  cutout: '60%',
  hover: { mode: null },
  plugins: {
    legend: {
      display: false
    },
    tooltip: null
  }
} as unknown as ChartOptions<'doughnut'>;

const DoughnutCard = ({ diff }: DoughnutCardProps) => {
  const { label, color } = serpDifficuly(diff);
  return (
    <Card className="h-md-100">
      <FalconCardHeader
        title={
          <div>
            میزان سختی کلمه
            <HelpTooltip html={serpTooltips.wordDiff} />
          </div>
        }
        titleTag="h6"
        className="py-2"
        light
        endEl={
          <Dropdown
            align="end"
            className="btn-reveal-trigger d-inline-block me-0"
          >
            <Dropdown.Toggle
              className="text-600 btn-reveal"
              split
              variant="reveal"
              size="sm"
            >
              <FontAwesomeIcon icon="ellipsis-h" className="fs--2" />
            </Dropdown.Toggle>
            <Dropdown.Menu className="border py-0">
              <Dropdown.Item className="link-600 fs--1 d-flex align-items-center gap-1 py-1">
                ذخیره تصویر
              </Dropdown.Item>
              <Dropdown.Item className="link-600 fs--1  d-none d-md-flex align-items-center gap-1 py-1">
                تمام صفحه
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        }
      />
      <Card.Body>
        <div
          className="text-center m-auto"
          style={{ maxWidth: diff !== 101 ? '14.625rem' : '100%' }}
        >
          <div className="mb-n6">
            {diff !== 101 ? (
              <Doughnut
                data={{
                  labels: ['Reached', 'Remaining'],
                  datasets: [
                    {
                      data: [diff, 100 - diff],
                      backgroundColor: [color, getColor('gray-300')],
                      borderColor: [color, getColor('gray-300')]
                    }
                  ]
                }}
                options={doughnutOptions}
                width={310}
              />
            ) : (
              <SemiCircleChartSkeleton title="" tooltip="" />
            )}
          </div>
          <div className="d-flex flex-column gap-0">
            <div className="d-inline-block mb-0 mt-n5 fw-medium font-sans-serif">
              <span className="fw-bold">
                {diff !== 101 ? (
                  <span className="fs-5">{diff}%</span>
                ) : (
                  <span style={{ color: '#b50000' }}>خطا رخ داد!!!</span>
                )}
              </span>
            </div>
          </div>
          <div className="fs-1 mt-n2">{diff !== 101 && label}</div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default DoughnutCard;
